import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import {
  FormBuilder,
  FormArray,
  FormGroup,
  FormControl,
  Validators,
} from '@angular/forms';
import { BulkOrderFormService } from 'src/app/_services/bulk-order-form.service';

@Component({
  selector: 'app-bulk-orders-form',
  templateUrl: './bulk-orders-form.component.html',
  styleUrls: ['./bulk-orders-form.component.scss'],
})
export class BulkOrdersFormComponent implements OnInit {
  @Input() submitted = false;
  @Input() selectedOrderType: any;
  @Input() totalQty!: number;
  @Input() selectedType: any;
  maxQty: number = 160;
  @Output() quantityChange = new EventEmitter<number>();
  value1!: number;
  errorUneven = false;
  @Input() data: any;

  // Selected values for the dropdowns
  selectedBiocross: any;
  @Input() inputFormGroup: FormGroup | undefined; // Explicitly state that it’s a FormGroup

  constructor(private bulkOrderFormService: BulkOrderFormService) {}

  ngOnInit(): void {

    
  }

  sizes = [
    { value: 'A5', viewValue: 'A5' },
    { value: 'A4', viewValue: 'A4' },
  ];

  // Logic to determine if a dropdown is required for the order type
  hasDropdown(orderType: string): boolean {
    return (
      orderType === 'A5 Biocross' ||
      orderType === 'A4 Cashpath' ||
      orderType === 'A4 (Cyto, Downs, Gynae, Histo)'
    );
  }

  onQuantityChange() {
    let qty = this.inputFormGroup!.get('quantity')?.value || 0;
    this.quantityChange.emit(qty);

    // check if the qty is an odd number and increment the value by 1
    if (qty % 2 !== 0) {
      qty = 0;
      this.inputFormGroup?.patchValue({ quantity: qty });
      this.errorUneven = true;
    } else {
      this.errorUneven = false;
    }
  }
}
